import {useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'

import {codeViewBlobLayoutRoute} from '../routes/code-view-blob-layout-route'

export function useSuspenseStyledBlob() {
  return useSuspenseRouteQuery(codeViewBlobLayoutRoute, 'codeViewBlobLayoutRoute.StyledBlob').data
}
